export class JobTitle {
    Id: number;
    Description: string;

    constructor() {
        this.Id = -1;
        this.Description = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/jobtitle/jobtitle.ts